// removed by extract-text-webpack-plugin
module.exports = {"empty":"_3H2ssBUho68TGwkEqWiGMQ","article":"_2jwgMFDkSKSr-foNIF_7f9","share":"_2_c4OFzQSPdm_rSQdRoBNt","articleBody":"PGIVj9NTYRWLNncBni330","date":"_2rgIsi3tJYjXp_0uWKfrBZ","content":"nOk1K0s0zezhHodo4OuM3","image":"_2yWxQtB7xJRsFyvEkRLyW_","author":"_3CWmWgSUSIso1llIkUNkaV","nextPrevWrap":"_1-2F_lVDyttcjseDXOyoFA","nextPrevWrapSingle":"_3YhvcOZ3hSaDLRBpg3q_dC","nextPrev":"_1AtZHRrbqUg7Q5LenEHdxv","contentPreloader":"_36HiKf1PpVafk-sdp3HAzy"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Blog/Articles.scss
// module id = 2886
// module chunks = 0